export const legacyKeysMap = {
  ImageExperience_Image: _TL_('Image'),
  ImageExperience_SelectedImage: _TL_('Selected image'),
  ImageExperience_SuggestionExceedsMaximum: _TL_('Suggestions found from your site exceed the maximum. We will restrict to max {{imageSize}} images.'),
  Escape_From_Image_List_Tip: _TL_('Use escape to navigate out of the image list'),
  'Found {{totalCount}} Results': _TL_('Found {{totalCount}} Results'),
  'No results found': _TL_('No results found'),
};
